import React, {Component} from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import IconBase from "@irati/ui/src/Icon"

import {TextButton} from "@irati/ui/src/Button"
import {Wrapper, WrapperNoNumber} from "../styled"
import Number from "./Number"

interface Props extends WithDefaultTheme {
  active?: boolean
  icon: string
  number: number
  onClick: () => void
  id: string
}

class Icon extends Component<Props> {
  static defaultProps = {
    active: false,
    number: 0,
    onClick: () => {}
  }

  state = {
    hover: false
  }

  handleMouseOver = () => this.setState({hover: true})

  handleMouseOut = () => this.setState({hover: false})

  render() {
    const {hover} = this.state
    const {onClick, icon, number, id, theme, ...props} = this.props

    const hasNumber = number > 0
    const Container = hasNumber ? Wrapper : WrapperNoNumber

    return (
      <TextButton onClick={onClick} id={id}>
        <Container {...props} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
          <IconBase icon={icon} color={hover || props.active ? theme.colors.primary1 : theme.colors.utility.ink} />
          {hasNumber && <Number>{number}</Number>}
        </Container>
      </TextButton>
    )
  }
}

export default withTheme(Icon)
